/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 02/05/22
 */

type LabelType = {
    type: string;
    label: string | null;
    value: string | null;
};

export const renderHeadingWithURL = (text: string) => {
    const schemaURLRegex = /\$url\['(.+?)', *'(.+?)'\]/g;
    const reg = Array.from(text.matchAll(schemaURLRegex));
    if (reg.length === 0) {
        return [
            {
                type: 'text',
                label: '',
                value: text,
            },
        ];
    } else {
        const finalResult: LabelType[] = [];
        let left = 0;
        let right = reg[0].index || 0;
        let i = 0;
        while (i < reg.length) {
            const subStr = text.substring(left, right);
            left = right;
            if (subStr.match(schemaURLRegex) !== null) {
                // this substring is a url -> next subtring is a text
                const groups = schemaURLRegex.exec(subStr);
                const label = groups && groups[1];
                const value = groups && groups[2];
                finalResult.push({
                    type: 'url',
                    label: label,
                    value: value,
                });

                i++;
                if (reg[i]) {
                    right = reg[i].index ?? 0;
                }
            } else {
                // this substring is a text -> next substring is a url
                finalResult.push({
                    type: 'text',
                    label: '',
                    value: subStr,
                });

                right = right + reg[i][0].length;
            }
        }
        const remainingSubStr = text.substring(right, text.length);
        finalResult.push({
            type: 'text',
            label: '',
            value: remainingSubStr,
        });
        return finalResult;
    }
};
